<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header marco-login row">

        <!-- PANEL IZQUIERDO: imagen + animación vertical -->
        <div class="col-12 col-sm-6 qs-panel" :style="{
          backgroundImage: 'url(' + bgImage + ')',
          backgroundSize: 'auto 100%',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat'
        }">
          <!--
            viewBox 360×480 (portrait 3:4) → escala a toda la altura del panel sin recorte.
            Narrativa vertical: TIP arriba → núcleo centro → 4 canales abajo → reply.
          -->
          <svg class="qscene"
               viewBox="0 0 360 480"
               preserveAspectRatio="xMidYMid meet"
               aria-hidden="true">
            <defs>
              <pattern id="qs-dot" width="28" height="28" patternUnits="userSpaceOnUse">
                <circle cx="14" cy="14" r="0.8" fill="#1b2532"/>
              </pattern>
            </defs>

            <!-- Overlay oscuro + dot grid -->
            <rect width="360" height="480" fill="rgba(7,11,18,0.70)"/>
            <rect width="360" height="480" fill="url(#qs-dot)" opacity="0.55"/>

            <!-- ── TIP CARD (centrada arriba) ── -->
            <g class="qs-in" transform="translate(130, 15)">
              <rect width="100" height="65" rx="9" fill="#0e141f" stroke="#f5a623" stroke-width="1.5"/>
              <text x="50" y="17" text-anchor="middle" fill="#f5a623"
                    font-family="Inter,system-ui,sans-serif" font-size="8" font-weight="700" letter-spacing="1.5">TIP</text>
              <rect class="qs-line qs-line--1" x="10" y="25" width="80" height="5" rx="2.5" fill="#243040"/>
              <rect class="qs-line qs-line--2" x="10" y="36" width="64" height="5" rx="2.5" fill="#243040"/>
              <rect class="qs-line qs-line--3" x="10" y="47" width="48" height="5" rx="2.5" fill="#243040"/>
              <rect x="8" y="54" width="84" height="7" rx="3.5" fill="#0c2a1a"/>
              <text x="50" y="62" text-anchor="middle" fill="#2ee27f" font-family="monospace" font-size="7">● publicar</text>
            </g>

            <!-- ── CABLE ENTRADA (vertical hacia abajo) ── -->
            <path d="M180,80 C180,108 180,140 180,152" stroke="#1b2532" stroke-width="1.5" fill="none"/>
            <path d="M180,80 C180,108 180,140 180,152"
                  pathLength="100" class="qs-pulse qs-pulse--in"
                  stroke="#f5a623" stroke-width="2" fill="none" stroke-linecap="round"/>

            <!-- ── NÚCLEO (centro del panel) ── -->
            <g transform="translate(180, 200)">
              <circle class="qs-halo" cx="0" cy="0" r="62" fill="none" stroke="#f5a623" stroke-width="1"/>
              <circle class="qs-ring" cx="0" cy="0" r="52" fill="none" stroke="#1b2532" stroke-width="1.5" stroke-dasharray="4 8"/>
              <circle class="qs-ring-pulse" cx="0" cy="0" r="46" fill="none" stroke="#f5a623" stroke-width="1.5" stroke-dasharray="12 88"/>
              <circle cx="0" cy="0" r="38" fill="#0b111a" stroke="#243040" stroke-width="1.5"/>
              <image :href="logo" x="-19" y="-19" width="38" height="38" class="qs-mark"/>
              <text class="qs-phase qs-phase--1" x="0" y="56" text-anchor="middle"
                    fill="#f5a623" font-family="monospace" font-size="8" letter-spacing="1">▼ VALIDAR</text>
              <text class="qs-phase qs-phase--2" x="0" y="56" text-anchor="middle"
                    fill="#f5a623" font-family="monospace" font-size="8" letter-spacing="1">▼ PROCESAR</text>
              <text class="qs-phase qs-phase--3" x="0" y="56" text-anchor="middle"
                    fill="#f5a623" font-family="monospace" font-size="8" letter-spacing="1">▼ DISTRIBUIR</text>
            </g>

            <!-- ── CABLES ABANICO (de núcleo a 4 canales) ── -->
            <path d="M172,248 C140,278 58,292 58,320"   stroke="#1b2532" stroke-width="1.5" fill="none"/>
            <path d="M172,248 C140,278 58,292 58,320"   pathLength="100" class="qs-pulse qs-pulse--out qs-pulse--out-1" stroke="#f5a623" stroke-width="2" fill="none" stroke-linecap="round"/>
            <path d="M177,248 C160,280 138,292 138,320" stroke="#1b2532" stroke-width="1.5" fill="none"/>
            <path d="M177,248 C160,280 138,292 138,320" pathLength="100" class="qs-pulse qs-pulse--out qs-pulse--out-2" stroke="#f5a623" stroke-width="2" fill="none" stroke-linecap="round"/>
            <path d="M183,248 C200,280 222,292 222,320" stroke="#1b2532" stroke-width="1.5" fill="none"/>
            <path d="M183,248 C200,280 222,292 222,320" pathLength="100" class="qs-pulse qs-pulse--out qs-pulse--out-3" stroke="#f5a623" stroke-width="2" fill="none" stroke-linecap="round"/>
            <path d="M188,248 C220,278 302,292 302,320" stroke="#1b2532" stroke-width="1.5" fill="none"/>
            <path d="M188,248 C220,278 302,292 302,320" pathLength="100" class="qs-pulse qs-pulse--out qs-pulse--out-4" stroke="#f5a623" stroke-width="2" fill="none" stroke-linecap="round"/>

            <!-- ── CANALES (4 horizontales debajo del núcleo, 72×44 cada uno) ── -->
            <g class="qs-chan qs-chan--1" transform="translate(22, 320)">
              <rect width="72" height="44" rx="7" fill="#0e141f" stroke="#1b2532" stroke-width="1"/>
              <text x="36" y="13" text-anchor="middle" fill="#7c8ba1" font-family="monospace" font-size="7">Beta</text>
              <rect x="8" y="18" width="38" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="26" width="28" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="33" width="56" height="7" rx="3" fill="#0c2a1a"/>
              <text x="36" y="39" text-anchor="middle" fill="#2ee27f" font-family="monospace" font-size="6" font-weight="700">sent</text>
            </g>
            <g class="qs-chan qs-chan--2" transform="translate(102, 320)">
              <rect width="72" height="44" rx="7" fill="#0e141f" stroke="#1b2532" stroke-width="1"/>
              <text x="36" y="13" text-anchor="middle" fill="#7c8ba1" font-family="monospace" font-size="7">Oro</text>
              <rect x="8" y="18" width="42" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="26" width="32" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="33" width="56" height="7" rx="3" fill="#0c2a1a"/>
              <text x="36" y="39" text-anchor="middle" fill="#2ee27f" font-family="monospace" font-size="6" font-weight="700">sent</text>
            </g>
            <g class="qs-chan qs-chan--3" transform="translate(186, 320)">
              <rect width="72" height="44" rx="7" fill="#0e141f" stroke="#1b2532" stroke-width="1"/>
              <text x="36" y="13" text-anchor="middle" fill="#7c8ba1" font-family="monospace" font-size="7">VIP</text>
              <rect x="8" y="18" width="34" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="26" width="26" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="33" width="56" height="7" rx="3" fill="#241a09"/>
              <text x="36" y="39" text-anchor="middle" fill="#f5a623" font-family="monospace" font-size="6" font-weight="700">queue</text>
            </g>
            <g class="qs-chan qs-chan--4" transform="translate(266, 320)">
              <rect width="72" height="44" rx="7" fill="#0e141f" stroke="#1b2532" stroke-width="1"/>
              <text x="36" y="13" text-anchor="middle" fill="#7c8ba1" font-family="monospace" font-size="7">Pro</text>
              <rect x="8" y="18" width="36" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="26" width="30" height="4" rx="2" fill="#1b2532"/>
              <rect x="8" y="33" width="56" height="7" rx="3" fill="#0c2a1a"/>
              <text x="36" y="39" text-anchor="middle" fill="#2ee27f" font-family="monospace" font-size="6" font-weight="700">sent</text>
            </g>

            <!-- ── BURBUJA REPLY ── -->
            <g class="qs-reply" transform="translate(135, 390)">
              <rect width="90" height="22" rx="6" fill="#111926" stroke="#f5a623" stroke-width="1"/>
              <text x="45" y="15" text-anchor="middle" fill="#f5a623" font-family="monospace" font-size="9">👍 suscriptor</text>
            </g>

            <!-- ── CABLE VUELTA (C4 derecha → núcleo por la derecha) ── -->
            <path d="M338,342 C375,352 378,175 228,200" stroke="#1b2532" stroke-width="1" fill="none" stroke-dasharray="4 6"/>
            <path d="M338,342 C375,352 378,175 228,200"
                  pathLength="100" class="qs-pulse qs-pulse--back"
                  stroke="#f5a623" stroke-width="1.5" fill="none" stroke-linecap="round"/>

          </svg>
        </div>

        <!-- PANEL DERECHO: destellos + card de login -->
        <div class="col-12 col-sm-6 centrado">

          <!-- Destellos decorativos (solo desktop) -->
          <div class="sparkle-bg" aria-hidden="true">
            <span class="sp" style="--sx:8%;--sy:12%;--sd:0s;--ss:3px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:22%;--sy:78%;--sd:0.4s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:65%;--sy:8%;--sd:0.9s;--ss:2.5px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:15%;--sy:45%;--sd:1.5s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:78%;--sy:55%;--sd:0.2s;--ss:3px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:40%;--sy:25%;--sd:1.8s;--ss:1.5px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:90%;--sy:30%;--sd:0.7s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:55%;--sy:80%;--sd:1.1s;--ss:2.5px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:30%;--sy:60%;--sd:2.2s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:80%;--sy:15%;--sd:1.4s;--ss:3px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:12%;--sy:85%;--sd:0.6s;--ss:2px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:70%;--sy:70%;--sd:1.9s;--ss:1.5px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:48%;--sy:48%;--sd:0.3s;--ss:2.5px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:92%;--sy:75%;--sd:2.5s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:5%;--sy:35%;--sd:1.7s;--ss:3px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:60%;--sy:38%;--sd:0.1s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:35%;--sy:92%;--sd:2.8s;--ss:2.5px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:82%;--sy:88%;--sd:1.3s;--ss:2px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:18%;--sy:20%;--sd:2.1s;--ss:1.5px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:50%;--sy:65%;--sd:0.8s;--ss:3px;--sc:#f5a623"></span>
            <span class="sp" style="--sx:73%;--sy:42%;--sd:2.4s;--ss:2px;--sc:#7c8ba1"></span>
            <span class="sp" style="--sx:45%;--sy:10%;--sd:1.6s;--ss:2.5px;--sc:#f5a623"></span>
          </div>

          <div class="login-card" :class="{ 'login-card--expanded': mostrarFormTipster }">
            <img :src="logo" class="navbar-brand-img w-100" alt="Quanty"/>
            <div v-if="modo=='login'" key="login" class="mt-5">
              <p>¿Tienes cuenta?</p>
              <QBtn variant="tipster" label="Inicia sesión" :block="true" @click="modalActive = true"/>
              <hr/>
              <p class="legal-18 text-muted">
                Acceso reservado a mayores de 18 años.
              </p>
            </div>

            <!-- ¿Te gustaría utilizar nuestra plataforma? -->
            <div class="tipster-toggle" @click="toggleFormTipster">
              <span>¿Quieres vender tus pronósticos por nuestra plataforma?</span>
              <span class="tipster-toggle__icon">{{ mostrarFormTipster ? '▲' : '▼' }}</span>
            </div>

            <div v-if="mostrarFormTipster" class="tipster-form">
              <div v-if="tipsterEnviado" class="tipster-ok">
                ✅ Solicitud enviada. Nos pondremos en contacto contigo pronto.
              </div>
              <form v-else @submit.prevent="enviarSolicitudTipster" novalidate>
                <div class="tipster-field">
                  <label>Nombre completo *</label>
                  <input v-model="formTipster.nombre" type="text" maxlength="150" required placeholder="Tu nombre"/>
                </div>
                <div class="tipster-field">
                  <label>Canal de Telegram *</label>
                  <input v-model="formTipster.canal_principal" type="text" maxlength="255" required placeholder="@micanal o https://t.me/micanal"/>
                </div>
                <div class="tipster-field">
                  <label>Número de suscriptores *</label>
                  <input v-model.number="formTipster.num_suscriptores" type="number" min="0" required placeholder="0"/>
                </div>
                <div class="tipster-field">
                  <label>Teléfono *</label>
                  <input v-model="formTipster.telefono" type="tel" maxlength="30" required placeholder="+34 600 000 000"/>
                </div>
                <div class="tipster-field">
                  <label>Email de contacto *</label>
                  <input v-model="formTipster.email" type="email" maxlength="190" required placeholder="tu@email.com"/>
                </div>
                <div class="tipster-field">
                  <label>País *</label>
                  <select v-model="formTipster.pais" required>
                    <option value="">— Selecciona tu país —</option>
                    <optgroup label="Más frecuentes">
                      <option>España</option>
                      <option>México</option>
                      <option>Argentina</option>
                      <option>Colombia</option>
                      <option>Chile</option>
                      <option>Perú</option>
                      <option>Venezuela</option>
                      <option>Ecuador</option>
                      <option>Bolivia</option>
                      <option>Uruguay</option>
                      <option>Paraguay</option>
                      <option>Costa Rica</option>
                      <option>Guatemala</option>
                      <option>Honduras</option>
                      <option>El Salvador</option>
                      <option>Nicaragua</option>
                      <option>Panamá</option>
                      <option>Cuba</option>
                      <option>República Dominicana</option>
                      <option>Puerto Rico</option>
                    </optgroup>
                    <optgroup label="Resto del mundo">
                      <option>Alemania</option>
                      <option>Andorra</option>
                      <option>Angola</option>
                      <option>Arabia Saudita</option>
                      <option>Australia</option>
                      <option>Austria</option>
                      <option>Bélgica</option>
                      <option>Brasil</option>
                      <option>Canadá</option>
                      <option>China</option>
                      <option>Dinamarca</option>
                      <option>Emiratos Árabes Unidos</option>
                      <option>Estados Unidos</option>
                      <option>Filipinas</option>
                      <option>Finlandia</option>
                      <option>Francia</option>
                      <option>Ghana</option>
                      <option>Grecia</option>
                      <option>India</option>
                      <option>Indonesia</option>
                      <option>Irlanda</option>
                      <option>Israel</option>
                      <option>Italia</option>
                      <option>Japón</option>
                      <option>Kenia</option>
                      <option>Luxemburgo</option>
                      <option>Marruecos</option>
                      <option>Nigeria</option>
                      <option>Noruega</option>
                      <option>Nueva Zelanda</option>
                      <option>Países Bajos</option>
                      <option>Polonia</option>
                      <option>Portugal</option>
                      <option>Reino Unido</option>
                      <option>Rumanía</option>
                      <option>Rusia</option>
                      <option>Senegal</option>
                      <option>Sudáfrica</option>
                      <option>Suecia</option>
                      <option>Suiza</option>
                      <option>Turquía</option>
                      <option>Ucrania</option>
                      <option>Otro</option>
                    </optgroup>
                  </select>
                </div>

                <label class="tipster-acepta">
                  <input type="checkbox" v-model="formTipster.acepta" />
                  <span>Autorizo al equipo de Quanty a utilizar mis datos para ponerse en contacto conmigo.</span>
                </label>

                <div id="turnstile-container" class="tipster-turnstile"></div>

                <div v-if="tipsterError" class="tipster-error">{{ tipsterError }}</div>

                <button type="submit" class="tipster-btn" :disabled="tipsterLoading">
                  {{ tipsterLoading ? 'Enviando…' : 'Enviar solicitud' }}
                </button>
              </form>
            </div>

          </div>
        </div>

      </div>
    </section>
  </main>

  <Modal @close="InicioSesionModal" @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <inicio-sesion-form @cerrar-modal="() => { cerrarModal(); }" :key="0" :esVisible="modalActive"></inicio-sesion-form>
    </div>
  </Modal>
</template>

<script>
import InicioSesionForm from './components/InicioSesionForm.vue';
import Modal from './components/Modal.vue';
import showSwal from "/src/mixins/showSwal.js";
import logo from "@/assets/img/quanty.png";
import bgImage from "@/assets/img/desadev.png";
import axios from "axios";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import * as yup from "yup";
import { ref } from 'vue';

export default {
  name: "Login",
  components: { Modal, InicioSesionForm },
  data() {
    const schema = yup.object().shape({
      usuario: yup.string().required("Debe indicar su usuario!"),
      password: yup.string().required("Debe indicar su clave!"),
    });
    return {
      loading: false,
      user: { usuario: "", password: "" },
      schema,
      modo: 'login',
      logo,
      bgImage,
      mostrarFormTipster: false,
      tipsterEnviado: false,
      tipsterLoading: false,
      tipsterError: '',
      turnstileToken: '',
      formTipster: {
        nombre: '',
        canal_principal: '',
        num_suscriptores: '',
        telefono: '',
        email: '',
        pais: '',
        acepta: false,
      },
    };
  },
  created() {
    this.modo = 'login';
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
    body.style.overflowY = 'hidden';
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
    body.style.overflowY = '';
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    toggleFormTipster() {
      this.mostrarFormTipster = !this.mostrarFormTipster;
      if (this.mostrarFormTipster) {
        this.$nextTick(() => this.cargarTurnstile());
      }
    },

    cargarTurnstile() {
      const container = document.getElementById('turnstile-container');
      if (!container) return;
      container.innerHTML = '';
      this.turnstileToken = '';

      const renderWidget = () => {
        if (window.turnstile) {
          window.turnstile.render('#turnstile-container', {
            sitekey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
            theme: 'dark',
            callback: (token) => { this.turnstileToken = token; },
            'expired-callback': () => { this.turnstileToken = ''; },
            'error-callback': () => { this.turnstileToken = ''; },
          });
        }
      };

      if (window.turnstile) {
        renderWidget();
      } else if (!document.getElementById('cf-turnstile-script')) {
        const script = document.createElement('script');
        script.id = 'cf-turnstile-script';
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.onload = renderWidget;
        script.onerror = () => console.error('[Turnstile] Error cargando el script de Cloudflare');
        document.head.appendChild(script);
      } else {
        // script ya cargado, esperar a que turnstile esté disponible
        let intentos = 0;
        const wait = setInterval(() => {
          intentos++;
          if (window.turnstile) {
            clearInterval(wait);
            renderWidget();
          } else if (intentos > 50) {
            clearInterval(wait);
            console.error('[Turnstile] Timeout esperando window.turnstile');
          }
        }, 100);
      }
    },

    async enviarSolicitudTipster() {
      this.tipsterError = '';
      if (!this.formTipster.acepta) {
        this.tipsterError = 'Debes autorizar el uso de tus datos para continuar.';
        return;
      }
      if (!this.turnstileToken) {
        this.tipsterError = 'Por favor, completa la verificación de seguridad.';
        return;
      }
      this.tipsterLoading = true;
      try {
        const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '');
        await axios.post(base + '/api/v2/solicitud-tipster', {
          ...this.formTipster,
          turnstile_token: this.turnstileToken,
        }, { timeout: 15000 });
        this.tipsterEnviado = true;
      } catch (err) {
        const msg = err?.response?.data?.mensaje || 'Error al enviar la solicitud. Inténtalo de nuevo.';
        this.tipsterError = msg;
        if (window.turnstile) window.turnstile.reset('#turnstile-container');
        this.turnstileToken = '';
      } finally {
        this.tipsterLoading = false;
      }
    },

    async handleLogin() {
      this.loading = true;
      try {
        await this.$store.dispatch("auth/login", this.user);
        const attrs = this.$store.state.auth?.me?.data?.attributes || this.$store.state.auth?.me || {};
        const permisosFinales = Array.isArray(attrs.permisos_finales) ? attrs.permisos_finales : [];
        localStorage.setItem("permisos_finales", JSON.stringify(permisosFinales));
        const rolEfectivo = Number(attrs.rol_efectivo ?? attrs.rol_id ?? attrs.rol ?? 0);
        localStorage.setItem("usuarioRolId", String(rolEfectivo));

        // Escribir datos de perfil en localStorage (mismo patrón que InicioSesionForm.vue)
        await this.$store.dispatch("profile/getProfile");
        const profile = this.$store.getters["profile/profile"];
        if (profile) {
          localStorage.setItem("usuarioNombre", profile.name || '');
          localStorage.setItem("usuarioEmail", profile.email || '');
          localStorage.setItem("usuarioTipsterId", profile.tipster_id || '');
        }
        const redirect = this.$route.query?.redirect;
        if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
          this.$router.push(redirect);
        } else if (rolEfectivo === 5) {
          this.$router.push({ name: "PanelPublicista" });
        } else if (rolEfectivo === 4) {
          this.$router.push({ name: "PanelTipster" });
        } else if (rolEfectivo === 3) {
          this.$router.push({ name: "PanelCliente" });
        } else {
          this.$router.push("/dashboard");
        }
      } catch (error) {
        if (error.response) {
          showSwal.methods.showSwal({ type: "error", message: "Datos de acceso erróneos" });
        }
        this.loading = false;
      }
    },
  },
  setup() {
    const modalActive = ref(false);
    const InicioSesionModal = () => { modalActive.value = !modalActive.value; };
    const cerrarModal = () => { modalActive.value = false; };
    return { modalActive, InicioSesionModal, cerrarModal };
  }
};
</script>

<style scoped>
/* ─── Layout base ─── */
.marco-login {
  height: 100vh !important;
  margin: 0 !important;
}
.marco-login > div { height: 100%; }
.main-content { margin: 0 !important; }

/* ─── Panel izquierdo: imagen + SVG overlay ─── */
.qs-panel {
  position: relative;
  background: #070b12;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* SVG llena el panel y escala con meet (sin recorte) */
.qscene {
  --q-loop: 10s;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

/* ─── Panel derecho: card centrada + sparkles ─── */
.centrado {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: var(--q-bg);
}
.login-card {
  position: relative;
  z-index: 1;
  width: 380px;
  max-width: calc(100vw - 2rem);
  background: var(--q-card);
  border-radius: 1.25rem;
  padding: 2.5rem;
  box-shadow: 0 6px 36px rgba(0,0,0,0.13);
}
.login-card p {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--q-text);
  margin: 0;
  line-height: 2rem;
  text-align: center;
}
hr { margin: 2rem 0 !important; }
.legal-18 {
  font-size: .85rem;
  line-height: 1.2rem;
  margin-top: -1rem;
  text-align: center;
}

/* ─── Destellos (sparkles) en panel derecho ─── */
.sparkle-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}
.sp {
  position: absolute;
  left: var(--sx);
  top: var(--sy);
  width: var(--ss);
  height: var(--ss);
  border-radius: 50%;
  background: var(--sc);
  animation: sp-twinkle 3s var(--sd) ease-in-out infinite alternate;
}
@keyframes sp-twinkle {
  0%   { opacity: 0;    transform: scale(0.5); }
  50%  { opacity: 0.55; transform: scale(1.4); }
  100% { opacity: 0.06; transform: scale(0.8); }
}

/* ─── Mobile ─── */
@media (max-width: 575px) {
  .qs-panel {
    position: fixed !important;
    top: 0; left: 0;
    width: 100% !important;
    height: 100vh !important;
    z-index: 0;
  }
  .qscene { display: none; }
  .sparkle-bg { display: none; }
  .centrado {
    position: fixed;
    top: 0; left: 0;
    width: 100%;
    height: 100vh;
    background: transparent;
    z-index: 10;
    padding: 1.5rem 1.25rem;
  }
  .login-card {
    max-width: 360px;
    padding: 2rem 1.5rem;
    box-shadow: 0 8px 32px rgba(0,0,0,0.55);
  }
}

/* ════════════════════════════════════════
   ANIMACIONES
   ════════════════════════════════════════ */

.qs-in { animation: qs-tip var(--q-loop) ease-in-out infinite; }
@keyframes qs-tip {
  0%   { opacity: 0; } 7%   { opacity: 1; }
  86%  { opacity: 1; } 94%  { opacity: 0; } 100% { opacity: 0; }
}

.qs-line {
  transform-box: fill-box;
  transform-origin: left center;
  animation: qs-lines var(--q-loop) ease-out infinite;
}
@keyframes qs-lines {
  0%, 2% { transform: scaleX(0); } 9%  { transform: scaleX(1); }
  86%    { transform: scaleX(1); } 94% { transform: scaleX(0); } 100% { transform: scaleX(0); }
}

.qs-pulse--in {
  stroke-dasharray: 7 100; opacity: 0;
  animation: qs-pin var(--q-loop) ease-in-out infinite;
}
@keyframes qs-pin {
  0%, 9% { stroke-dashoffset: 107; opacity: 0; }
  10%    { stroke-dashoffset: 107; opacity: 1; }
  19%    { stroke-dashoffset: 0;   opacity: 0; }
  100%   { opacity: 0; }
}

.qs-halo { opacity: 0; animation: qs-halo var(--q-loop) ease-in-out infinite; }
@keyframes qs-halo {
  0%, 17% { opacity: 0; } 24% { opacity: 0.5; }
  44%, 87%{ opacity: 0.28; } 95% { opacity: 0; } 100% { opacity: 0; }
}

.qs-ring {
  transform-box: fill-box; transform-origin: center;
  animation: qs-spin 24s linear infinite;
}
@keyframes qs-spin { to { transform: rotate(360deg); } }

.qs-ring-pulse {
  transform-box: fill-box; transform-origin: center; opacity: 0.1;
  animation: qs-rpulse var(--q-loop) ease-in-out infinite;
}
@keyframes qs-rpulse {
  0%, 17% { opacity: 0.1; stroke-dashoffset: 0; }
  22%, 44%{ opacity: 0.7; stroke-dashoffset: -60; }
  55%     { opacity: 0.1; stroke-dashoffset: -120; }
  100%    { opacity: 0.1; }
}

.qs-mark { opacity: 0.45; animation: qs-mark var(--q-loop) ease-in-out infinite; }
@keyframes qs-mark {
  0%, 16% { opacity: 0.4; } 25%, 87%{ opacity: 1; }
  95%     { opacity: 0.4; } 100%    { opacity: 0.4; }
}

.qs-phase { opacity: 0; }
.qs-phase--1 { animation: qs-ph1 var(--q-loop) ease-in-out infinite; }
@keyframes qs-ph1 { 0%,19%{opacity:0;} 22%,29%{opacity:1;} 32%{opacity:0;} 100%{opacity:0;} }
.qs-phase--2 { animation: qs-ph2 var(--q-loop) ease-in-out infinite; }
@keyframes qs-ph2 { 0%,30%{opacity:0;} 33%,38%{opacity:1;} 41%{opacity:0;} 100%{opacity:0;} }
.qs-phase--3 { animation: qs-ph3 var(--q-loop) ease-in-out infinite; }
@keyframes qs-ph3 { 0%,40%{opacity:0;} 43%,48%{opacity:1;} 51%{opacity:0;} 100%{opacity:0;} }

.qs-pulse--out { stroke-dasharray: 7 100; opacity: 0; }
.qs-pulse--out-1 { animation: qs-po1 var(--q-loop) ease-in-out infinite; }
@keyframes qs-po1 { 0%,41%{stroke-dashoffset:107;opacity:0;} 43%{stroke-dashoffset:107;opacity:1;} 53%{stroke-dashoffset:0;opacity:0;} 100%{opacity:0;} }
.qs-pulse--out-2 { animation: qs-po2 var(--q-loop) ease-in-out infinite; }
@keyframes qs-po2 { 0%,43%{stroke-dashoffset:107;opacity:0;} 45%{stroke-dashoffset:107;opacity:1;} 55%{stroke-dashoffset:0;opacity:0;} 100%{opacity:0;} }
.qs-pulse--out-3 { animation: qs-po3 var(--q-loop) ease-in-out infinite; }
@keyframes qs-po3 { 0%,45%{stroke-dashoffset:107;opacity:0;} 47%{stroke-dashoffset:107;opacity:1;} 57%{stroke-dashoffset:0;opacity:0;} 100%{opacity:0;} }
.qs-pulse--out-4 { animation: qs-po4 var(--q-loop) ease-in-out infinite; }
@keyframes qs-po4 { 0%,47%{stroke-dashoffset:107;opacity:0;} 49%{stroke-dashoffset:107;opacity:1;} 59%{stroke-dashoffset:0;opacity:0;} 100%{opacity:0;} }

.qs-chan { opacity: 0; }
.qs-chan--1 { animation: qs-ch1 var(--q-loop) ease-out infinite; }
@keyframes qs-ch1 { 0%,52%{opacity:0;} 58%{opacity:1;} 87%{opacity:1;} 94%{opacity:0;} 100%{opacity:0;} }
.qs-chan--2 { animation: qs-ch2 var(--q-loop) ease-out infinite; }
@keyframes qs-ch2 { 0%,55%{opacity:0;} 61%{opacity:1;} 87%{opacity:1;} 94%{opacity:0;} 100%{opacity:0;} }
.qs-chan--3 { animation: qs-ch3 var(--q-loop) ease-out infinite; }
@keyframes qs-ch3 { 0%,58%{opacity:0;} 64%{opacity:1;} 87%{opacity:1;} 94%{opacity:0;} 100%{opacity:0;} }
.qs-chan--4 { animation: qs-ch4 var(--q-loop) ease-out infinite; }
@keyframes qs-ch4 { 0%,61%{opacity:0;} 67%{opacity:1;} 87%{opacity:1;} 94%{opacity:0;} 100%{opacity:0;} }

.qs-reply { opacity: 0; animation: qs-reply var(--q-loop) ease-out infinite; }
@keyframes qs-reply { 0%,73%{opacity:0;} 79%{opacity:1;} 90%{opacity:1;} 96%{opacity:0;} 100%{opacity:0;} }

.qs-pulse--back {
  stroke-dasharray: 7 100; opacity: 0;
  animation: qs-pback var(--q-loop) ease-in-out infinite;
}
@keyframes qs-pback {
  0%,82%{ stroke-dashoffset:107; opacity:0; }
  84%   { stroke-dashoffset:107; opacity:1; }
  93%   { stroke-dashoffset:0;   opacity:0; }
  100%  { opacity:0; }
}

/* ─── Formulario tipster ─── */
.login-card--expanded {
  max-height: 90vh;
  overflow-y: auto;
}
.tipster-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.7rem 0;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--q-text, #203353);
  border-top: 1px solid rgba(0,0,0,0.08);
  margin-top: 0.5rem;
  user-select: none;
}
.tipster-toggle:hover { opacity: 0.75; }
.tipster-toggle__icon { font-size: 0.75rem; opacity: 0.7; }
.tipster-form {
  padding-top: 0.5rem;
}
.tipster-field {
  margin-bottom: 0.75rem;
}
.tipster-field label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--q-text, #344767);
  margin-bottom: 0.2rem;
}
.tipster-field input,
.tipster-field select {
  width: 100%;
  padding: 0.45rem 0.7rem;
  border: 1px solid rgba(0,0,0,0.15);
  border-radius: 0.5rem;
  font-size: 0.88rem;
  background: var(--q-card, #fff);
  color: var(--q-text, #344767);
  outline: none;
  transition: border-color .2s;
}
.tipster-field input:focus,
.tipster-field select:focus { border-color: #203353; }
.tipster-acepta {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
  margin: 0.75rem 0 0.25rem;
  font-size: 0.78rem;
  color: var(--q-text, #344767);
  line-height: 1.4;
}
.tipster-acepta input[type="checkbox"] {
  flex-shrink: 0;
  margin-top: 0.1rem;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.tipster-turnstile {
  margin: 0.8rem 0;
  min-height: 65px;
}
.tipster-btn {
  width: 100%;
  background: #203353;
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  padding: 0.6rem 1.2rem;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity .2s;
  margin-top: 0.25rem;
}
.tipster-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.tipster-btn:not(:disabled):hover { opacity: 0.85; }
.tipster-error {
  color: #dc3545;
  font-size: 0.82rem;
  margin-bottom: 0.5rem;
}
.tipster-ok {
  padding: 0.8rem;
  background: #e6f4ea;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  color: #1a6b35;
  text-align: center;
}

/* ─── Reduced motion ─── */
@media (prefers-reduced-motion: reduce) {
  .qs-in  { animation: none; opacity: 1; }
  .qs-line { animation: none; transform: scaleX(1); }
  .qs-halo { animation: none; opacity: 0.25; }
  .qs-ring { animation: none; }
  .qs-ring-pulse { animation: none; opacity: 0.15; }
  .qs-mark { animation: none; opacity: 1; }
  .qs-phase--1, .qs-phase--2 { animation: none; opacity: 0; }
  .qs-phase--3 { animation: none; opacity: 1; }
  .qs-pulse--in, .qs-pulse--out-1, .qs-pulse--out-2,
  .qs-pulse--out-3, .qs-pulse--out-4, .qs-pulse--back { animation: none; opacity: 0; }
  .qs-chan--1, .qs-chan--2, .qs-chan--3, .qs-chan--4 { animation: none; opacity: 1; }
  .qs-reply { animation: none; opacity: 1; }
  .sp { animation: none; opacity: 0.15; }
}
</style>
